export interface PlanModel{
    id?: string,
    planName: string;
    whenAreYouGoingToDoIt: number|null;
    planSpecificDate: Date|null;
    whatAreYouGoingToDo: string;
    difficultiesAndSolutions: string;
    finalPlan: string;
    planChecklist: any[];
    reminderFrequency: number|null;
    reminderWeeklyDayOfWeek: number|null; 
    reminderMonthlyDate: number|null;
    reminderSpecificDate: Date|null; 
    reminderTime: string|null;     
    showReminderDiv:boolean,
    showReminderDayOfWeek:boolean,
    showReminderDateOfMonth:boolean,
    showReminderSpecificDate:boolean,
    showPlanSpecificDateField:boolean,
}


export function PlanDefaultValues():PlanModel
{
    return {
        id: undefined,
        planName: '',
        whenAreYouGoingToDoIt: null, 
        planSpecificDate: null, 
        whatAreYouGoingToDo: '',
        difficultiesAndSolutions: '',
        finalPlan: '',
        planChecklist: [],
        reminderFrequency: null, 
        reminderWeeklyDayOfWeek: null, 
        reminderMonthlyDate: null, 
        reminderSpecificDate: null, 
        reminderTime: null,
        showReminderDiv:false,
        showReminderDayOfWeek:false,
        showReminderDateOfMonth:false,
        showReminderSpecificDate:false,
        showPlanSpecificDateField:false
    };
}

export interface ClosePlanModel{
    id: string;
    didYouTryToDoIt:boolean,
    wentWellAndNotSoWell:string,
    learnedFromWhatHappened:string,
    whatStoppedYouInternalThings:string,
    whatStoppedYouExternalThings:string,
    plannedToDealWithTheseThings:string
}

export function ClosePlanModelDefaultValues():ClosePlanModel
{
    return {
        id: '',
        didYouTryToDoIt:true,
        wentWellAndNotSoWell:'',
        learnedFromWhatHappened:'',
        whatStoppedYouInternalThings:'',
        whatStoppedYouExternalThings:'',
        plannedToDealWithTheseThings:''
    }
}

export interface ClosedPlanView {
    id: string; 
    planName: string;
    whenAreYouGoingToDoIt: string; 
    planSpecificDate: string; 
    showPlanSpecificDateField: boolean;
    whatAreYouGoingToDo: string;
    difficultiesAndSolutions: string;
    finalPlan: string; 
    reminderFrequency?: string;
    didYouTryToDoIt: boolean;
    wentWellAndNotSoWell?: string; 
    learnedFromWhatHappened?: string; 
    whatStoppedYouInternalThings?: string; 
    whatStoppedYouExternalThings?: string; 
    plannedToDealWithTheseThings?: string; 
}

export function ClosedPlanViewDefaultValues(): ClosedPlanView {
    return {
        id: '',
        planName: '',
        whenAreYouGoingToDoIt: '',
        planSpecificDate: '',
        showPlanSpecificDateField: false,
        whatAreYouGoingToDo: '',
        difficultiesAndSolutions: '',
        finalPlan: '',
        reminderFrequency: '',
        didYouTryToDoIt: false,
        wentWellAndNotSoWell: '',
        learnedFromWhatHappened: '',
        whatStoppedYouInternalThings: '',
        whatStoppedYouExternalThings: '',
        plannedToDealWithTheseThings: ''
        
    };
}
